module.exports = __webpack_public_path__ + "static/media/path.eae02102.svg";